<template>
  <div id="app" class="notranslate" translate="no">
    <Nav />
    <router-view/>
    <SummaryModal ref="summaryModal" v-show="isSummaryModalVisible" :summary="summary" @close="closeSummaryModal" />
    <ScorecardModal ref="scorecardModal" v-show="isModalVisible" :scorecard="scorecard" @close="closeModal" />
    <InfoModal ref="infoModal" v-show="isInfoModalVisible" @close="closeInfoModal" />
    <Footer />
    <loading-screen :is-loading="isLoading"></loading-screen>
  </div>
</template>

<script>
import Nav from './components/partials/Nav.vue';
import Footer from './components/partials/Footer.vue';
import ScorecardModal from "./components/ScorecardModal.vue";
import SummaryModal from "./components/SummaryModal.vue";
import InfoModal from "./components/InfoModal.vue";
import Loader from "./components/Loader";
import axios from "axios";
import moment from 'moment';
import { GameType } from './enum/gameType.js';

import SocketioService from './services/socketio.service.js';
//import { runInThisContext } from 'vm';

export default {
  name: 'app',
  data () {
    return {
      GameType,
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      tickerItems: new Array(),
      tickerItem: {},
      isModalVisible: false,
      isInfoModalVisible: false,
      isSummaryModalVisible: false,
      scorecard: null,
      summary: null,
      isLoading: true,
      token: process.env.VUE_APP_TOKEN,
      adminUsers: null
    }
  },
  components: {
    Nav,
    Footer,
    ScorecardModal,
    SummaryModal,
    InfoModal,
    'loading-screen': Loader
  },
  created() {
    console.log("SocketioService.setupSocketConnection()");
    SocketioService.setupSocketConnection();
  },
  beforeUnmount() {
    console.log("SocketioService.disconnect()");
    SocketioService.disconnect();
  },  
  methods:{
    isAdmin() {
      if (!this.$auth.isAuthenticated) {
        return false;
      } else {
        //console.log("isAdmin?", this.$auth.user.email);
        //console.log("admin users", this.adminUsers);
        for (var i = 0; i < this.adminUsers.length; i++) {
          if (this.adminUsers[i].email == this.$auth.user.email) {
            //console.log("found match:",this.adminUsers[i].email);
            return true;
          }
        }
        //console.log("no match found");
        return false;
      }
    },
    getAdminUsers() {
      var administrators = [
        {
          "email": "logroller1@yahoo.com"
        },
        {
          "email": "jamie.symonds@gmail.com"
        },
        {
          "email": "timberloungetv@gmail.com"
        },
        {
          "email": "suzyatwood24@gmail.com"
        },
        {
          "email": "wildaxetv@gmail.com"
        },
        {
          "email": "erickalynnsutherland@gmail.com"
        }
      ]
      this.adminUsers = administrators;
      /*
      var token = this.getApiToken();
      var url = (this.debugMode ? "http://localhost:8080/administrators/" : "https://axes2api.azurewebsites.net/administrators/")
      axios.get(url,{
        headers: {
          authorization: token
        }
      })
      .then((response) => {
        this.adminUsers = response.data; 
      }, (error) => {
        console.log(error);
      });
      */
    },
    showSummaryModal(summary) {
      this.summary = summary;
      this.isSummaryModalVisible = true;
    },
    closeSummaryModal() {
      this.isSummaryModalVisible = false;
      this.summary = {};
    },
    showModal(scorecard) {
      //console.log("showModal");
      //console.log(scorecard);
      this.isModalVisible = true;
      this.scorecard = scorecard;
    },
    closeModal() {
      this.isModalVisible = false;
      this.scoarecard = {};
    },
    showInfoModal() {
      this.isInfoModalVisible = true;
    },
    closeInfoModal() {
      this.isInfoModalVisible = false;
    },
    calculateTotalThrowsForRound: function(player, round, totalRoundsNum) {
      var total = 0;
      var playerId = player.id;
      if (round.type != "Practice" && round.type != "Finals") {
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            var matchPlayerId = matchPlayer.player.id;
            if (matchPlayerId == playerId) {
              var countThis = this.countThis(matchPlayer.bye, round, totalRoundsNum);
              if (countThis) {
                for (var a = 0; a < matchPlayer.throws.length; a++) {
                  var pThrow = matchPlayer.throws[a];
                  //console.log("............pThrow " + pThrow.basicScore);
                  total += parseInt(pThrow.basicScore);
                }
              }
            }
          }
        }
      }
      return total;
    },
    calculateTotalThrows: function(player, scorecard) {
      var total = 0;
      if (scorecard.gameType === GameType.TOURNAMENT) {
        for (var z = 0; z < scorecard.sets.length; z++) {
          var st = scorecard.sets[z];
          for(var x = 0; x < st.rounds.length; x++) {
            var round = st.rounds[x];
            total += this.calculateTotalThrowsForRound(player, round, null);
          }
        }
      } else {
        for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            total += this.calculateTotalThrowsForRound(player, round, scorecard.rounds.length);
        }
      }
      return total;
    },
    calculateTotalBullseyes: function(player, scorecard) {
      var total = 0;
      if (scorecard.gameType === GameType.TOURNAMENT) {
        for (var z = 0; z < scorecard.sets.length; z++) {
          var st = scorecard.sets[z];
          for(var x = 0; x < st.rounds.length; x++) {
            var round = st.rounds[x];
            total += this.calculateBullseyesForRound(player, round, null);
          }
        }
      } else {
        for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            total += this.calculateBullseyesForRound(player, round, scorecard.rounds.length);
        }
      }
      return total;
    },
    calculateTotalWins: function(player, scorecard) {
      var total = 0;
      for(var x = 0; x < scorecard.rounds.length; x++) {
        var round = scorecard.rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var plyr = match.matchPlayers[z];
            if (plyr.player.id == player.id) {
              if (plyr.winner) total++;
            }
          }
        }
      }
      return total;
    },
    calculateTotalLoss: function(player, scorecard) {
      var total = 0;
      for(var x = 0; x < scorecard.rounds.length; x++) {
        var round = scorecard.rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var plyr = match.matchPlayers[z];
            if (plyr.player.id == player.id) {
              if (!plyr.winner) total++;
            }
          }
        }
      }
      return total;
    },
    calculateTotalGP: function(player, scorecard) {
      var total = 0;
      for(var x = 0; x < scorecard.rounds.length; x++) {
        var round = scorecard.rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var plyr = match.matchPlayers[z];
            if (plyr.player.id == player.id) {
              total++;
            }
          }
        }
      }
      return total;
    },
    calculateBullseyesForRound: function(player, round, totalNumRounds) {
      var total = 0;
      if (round.type != "Finals" && round.type != "Practice") {
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            var matchPlayerId = matchPlayer.player.id;
            if (matchPlayerId == player.id) {
              var countThis = this.countThis(matchPlayer.bye, round, totalNumRounds);
              if (countThis) {
                for (var a = 0; a < matchPlayer.throws.length; a++) {
                  if (matchPlayer.throws[a].basicScore == "5" || matchPlayer.throws[a].basicScore == 5) total++;
                }
              }
            }
          }
        }
      }
      return total;
    },
    calculateThrowPoints: function (player) {
        var arr = [];
        if (this.gameData && this.gameData.rounds != null) {
            arr.push({label: '0', value: this.calculateAxeHit(player, this.gameData, 0)});
            arr.push({label: '1', value: this.calculateAxeHit(player, this.gameData, 1)});
            arr.push({label: '2', value: this.calculateAxeHit(player, this.gameData, 2)});
            arr.push({label: '3', value: this.calculateAxeHit(player, this.gameData, 3)});
            arr.push({label: '4', value: this.calculateAxeHit(player, this.gameData, 4)});
            arr.push({label: '5', value: this.calculateAxeHit(player, this.gameData, 5)});
        } else {
            arr.push({label: '0', value: 0});
            arr.push({label: '1', value: 0});
            arr.push({label: '2', value: 0});
            arr.push({label: '3', value: 0});
            arr.push({label: '4', value: 0});
            arr.push({label: '5', value: 0});
        }
        return arr;
    },    
    calculateThrows: function(player, scorecard) {
        var total = 0;
        if (scorecard.gameType === GameType.TOURNAMENT) {
            for(var z = 0; z < scorecard.sets.length; z++) {
                var st = scorecard.sets[z];
                for(var x = 0; x < st.rounds.length; x++) {
                    var round = st.rounds[x];
                    total += this.calculateThrowsForRound(player, round, scorecard.rounds.length);
                }
            }
        } else {
            for(var x = 0; x < scorecard.rounds.length; x++) {
                var round = scorecard.rounds[x];
                total += this.calculateThrowsForRound(player, round, scorecard.rounds.length);
            }
        }
        return total;
    },
    calculateThrowsForRound: function(player, round, totalNumRounds) {
      var total = 0;
      if (round.type != "Finals" && round.type != "Practice") {
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            var matchPlayerId = matchPlayer.player.id;
            if (matchPlayerId == player.id) {
              var countThis = this.countThis(matchPlayer.bye, round, totalNumRounds);
              if (countThis) {
                for (var a = 0; a < matchPlayer.throws.length; a++) {
                  total++;
                }
              }
            }
          }
        }
      }
      return total;
    },
    countThis: function(bye, round, totalRoundsNum) {
      //only used in round-robin (bye calculations)
      //return true if there is a subsequent round in regular gameplay, otherwise false.
      if (bye) {
        if (round.id === totalRoundsNum) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    calculateThrowsFinals: function(player, scorecard) {
        var total = 0;

        if (scorecard.gameType === GameType.TOURNAMENT) {
            for (var a = 0; a < scorecard.sets.length; a++) {
                var st = scorecard.sets[a];
                if (st.type && st.type === 'Finals') {
                    for(var x = 0; x < st.rounds.length; x++) {
                        var round = st.rounds[x];
                        for (var y = 0; y < round.matches.length; y++) {
                            var match = round.matches[y];
                            for (var z = 0; z < match.matchPlayers.length; z++) {
                                var matchPlayer = match.matchPlayers[z];
                                var matchPlayerId = (scorecard.gameType === GameType.TOURNAMENT ? matchPlayer.player.id : matchPlayer.id);
                                if (matchPlayerId == player.id) {
                                    for (var b = 0; b < matchPlayer.throws.length; b++) {
                                        total++;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            for(var x = 0; x < scorecard.rounds.length; x++) {
                var round = scorecard.rounds[x];
                if (round.type === "Finals") {
                    for (var y = 0; y < round.matches.length; y++) {
                        var match = round.matches[y];
                        for (var z = 0; z < match.matchPlayers.length; z++) {
                            var matchPlayer = match.matchPlayers[z];
                            var matchPlayerId = (scorecard.gameType === GameType.TOURNAMENT ? matchPlayer.player.id : matchPlayer.id);
                            if (matchPlayerId == player.id) {
                                for (var a = 0; a < matchPlayer.throws.length; a++) {
                                    total++;
                                }
                            }
                        }
                    }
                }
            }
        }
        return total;
    },
    calculateTotalThrowsFinals: function(player, scorecard) {
        //console.log("... calculateTotalThrowsFinals ...")
        var playerId = player.id;
        var total = 0;

        if (scorecard.gameType === GameType.TOURNAMENT) {
          for (var a = 0; a < scorecard.sets.length; a++) {
            var st = scorecard.sets[a];
            for(var x = 0; x < st.rounds.length; x++) {
              var round = st.rounds[x];
              if (round.type === "Finals") {
                for (var y = 0; y < round.matches.length; y++) {
                  var match = round.matches[y];
                  for (var z = 0; z < match.matchPlayers.length; z++) {
                    var matchPlayer = match.matchPlayers[z];
                    var matchPlayerId = matchPlayer.player.id;
                    if (matchPlayerId == playerId) {
                      for (var b = 0; b < matchPlayer.throws.length; b++) {
                        var pThrow = matchPlayer.throws[b];
                        //console.log("............pThrow " + pThrow.basicScore);
                        total += parseInt(pThrow.basicScore);
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            if (round.type === "Finals") {
              for (var y = 0; y < round.matches.length; y++) {
                var match = round.matches[y];
                for (var z = 0; z < match.matchPlayers.length; z++) {
                  var matchPlayer = match.matchPlayers[z];
                  var matchPlayerId = matchPlayer.id;
                  if (matchPlayerId == playerId) {
                    for (var a = 0; a < matchPlayer.throws.length; a++) {
                      var pThrow = matchPlayer.throws[a];
                      //console.log("............pThrow " + pThrow.basicScore);
                      total += parseInt(pThrow.basicScore);
                    }
                  }
                }
              }
            }
          }

        }


        //console.log("calculateTotalThrowsFinals: " + total);
        return total;
    },
    calculateAxeHitOnRound: function(playerId, round, basicScore) {
      var calculateThisRound = true;
      if (round.title !== undefined && round.title == 'Practice') calculateThisRound = false; 
      var total = 0;
      if (calculateThisRound) {
          for (var y = 0; y < round.matches.length; y++) {
              var match = round.matches[y];
              for (var z = 0; z < match.matchPlayers.length; z++) {
                  var matchPlayer = match.matchPlayers[z];
                  var matchPlayerId = matchPlayer.player.id;
                  //console.log("matchPlayerId", matchPlayerId);
                  if (matchPlayerId == playerId) {
                      for (var a = 0; a < matchPlayer.throws.length; a++) {
                        //throws = matchPlayer.throws.length;
                        var pThrow = matchPlayer.throws[a];
                        //console.log("............pThrow " + pThrow.basicScore);
                        var bScore = parseInt(pThrow.basicScore);
                        if (bScore === basicScore) {
                          total++;
                        }
                      }
                  }
              }
          }
      }
      return total;
    },
    calculateAxeHit: function (player, scorecard, basicScore) {
        var playerId = player.id;
        var total = 0;
        var basicScore = parseInt(basicScore);
        var rounds = 0;
        var throws = 0;
        var total_throws = 0;
        //console.log("calculateAxeHit", playerId);
        if (scorecard.sets != null && scorecard.sets.length > 0) {
          for (var z = 0; z < scorecard.sets.length; z++) {
            var set = scorecard.sets[z];
            //console.log("set", set)
            for(var x = 0; x < set.rounds.length; x++) {
              var round = set.rounds[x];
              total += this.calculateAxeHitOnRound(playerId, round, basicScore)
            }
          }
        } else if (scorecard.rounds != null && scorecard.rounds.length > 0) {
          for(var x = 0; x < scorecard.rounds.length; x++) {
            var round = scorecard.rounds[x];
            total += this.calculateAxeHitOnRound(playerId, round, basicScore)
          }
        }

        return total;
        /*
        total_throws = rounds * throws;
        var avg = (total / total_throws)*100;
        
        //var retStr = basicScore + ": " + total + " (" + avg.toFixed(0) + "%)";

        return avg.toFixed(0);
        */
    },
    createSparklineData(player, scorecard) {
      var data = [];
      //
      //
      //
      //
      //
      //
      return data;
    },
    calculateAverageThrow: function (player, scorecard) {
        //console.log("calculateAverageThrow")
        //console.log(player);

        var roundedAverage = 0;
        var total = 0;
        var throws = 0;
        var average = 0;

        if (scorecard.gameType === GameType.TOURNAMENT) {
          //console.log("CALCULATE AVERAGE THROW");
          //console.log("scorecard.sets.length: ", scorecard.sets.length);
          for (var z = 0; z < scorecard.sets.length; z++) {
            var st = scorecard.sets[z];
            //console.log("set",st);
            for(var x = 0; x < st.rounds.length; x++) {
              var round = st.rounds[x];
              //console.log("round", round);
              
              var result = this.calculateAverageThrowForRound(player, round, scorecard.gameType);

              total += result.total;
              throws += result.throws;
            }
            if (total === 0) return 0;
            average = total / throws;
            roundedAverage = (Math.round(average * 100) / 100);
          }
        } else {
          if (scorecard.rounds != null) {
            for(var x = 0; x < scorecard.rounds.length; x++) {
              var round = scorecard.rounds[x];

              var result = this.calculateAverageThrowForRound(player, round, scorecard.gameType, scorecard.rounds.length);

              total += result.total;
              throws += result.throws;

            }
            if (total === 0) return 0;
            average = total / throws;
            roundedAverage = (Math.round(average * 100) / 100);
          }
        }
        return roundedAverage;
    },
    calculateAverageThrowForRound: function (mPlayer, round, gameType, totalRoundsNum = null) {
      var total = 0;
      var throws = 0;
      var playerId = (mPlayer.player != null ? mPlayer.player.id : mPlayer.id);

      if (round.type != "Practice" && round.type != "Finals") {
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            var matchPlayerId = matchPlayer.player.id;
            if (matchPlayerId == playerId) {
              if (gameType === GameType.TOURNAMENT) {
                for (var a = 0; a < matchPlayer.throws.length; a++) {
                  var pThrow = matchPlayer.throws[a];
                  if (pThrow.scored) {
                    total += parseInt(pThrow.basicScore);
                    throws ++;
                  }
                }
              } else {
                var countThis = this.countThis(matchPlayer.bye, round, totalRoundsNum);
                if (countThis) {
                  for (var a = 0; a < matchPlayer.throws.length; a++) {
                    var pThrow = matchPlayer.throws[a];
                    total += parseInt(pThrow.basicScore);
                    throws ++;
                  }
                }
              }
            }
          }
        }
      }
      return { total: total, throws: throws };
    },
    calculateAverageThrowFinals: function (player, scorecard, totalRoundsNum) {
        //console.log("... calculateAverageThrowFinals ...");
        //console.log("player");
        //console.log(player);
        //console.log("scorecard");
        //console.log(scorecard);

        var roundedAverage = 0;
        var total = 0;
        var throws = 0;
        var average = 0;
        if (scorecard.gameType === GameType.TOURNAMENT) {
          var playerId = player.id;
          for (var a = 0; a < scorecard.sets.length; a++) {
            var st = scorecard.sets[a];
            if (st.type && st.type === 'Finals') {
              if (st.rounds != null) {
                for(var x = 0; x < st.rounds.length; x++) {
                  var round = st.rounds[x];
                  for (var y = 0; y < round.matches.length; y++) {
                    var match = round.matches[y];
                    for (var z = 0; z < match.matchPlayers.length; z++) {
                      var matchPlayer = match.matchPlayers[z];
                      var matchPlayerId = matchPlayer.player.id;
                      if (matchPlayerId == playerId) {
                        for (var b = 0; b < matchPlayer.throws.length; b++) {
                          var pThrow = matchPlayer.throws[b];
                          //console.log("............pThrow " + pThrow.basicScore);
                          total += parseInt(pThrow.basicScore);
                          throws ++;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          if (total === 0) return 0;
          average = total / throws;
          roundedAverage = (Math.round(average * 100) / 100);
        } else {
          var playerId = player.id;
          if (scorecard.rounds != null) {
            for(var x = 0; x < scorecard.rounds.length; x++) {
              var round = scorecard.rounds[x];
              if (round.type === "Finals") {
                for (var y = 0; y < round.matches.length; y++) {
                  var match = round.matches[y];
                  for (var z = 0; z < match.matchPlayers.length; z++) {
                      var matchPlayer = match.matchPlayers[z];
                      var matchPlayerId = matchPlayer.player.id;
                      if (matchPlayerId == playerId) {
                        for (var a = 0; a < matchPlayer.throws.length; a++) {
                          var pThrow = matchPlayer.throws[a];
                          //console.log("............pThrow " + pThrow.basicScore);
                          total += parseInt(pThrow.basicScore);
                          throws ++;
                        }
                      }
                    }
                  }
                }
              }
              if (total === 0) return 0;
              average = total / throws;
              roundedAverage = (Math.round(average * 100) / 100);
          }
        }
        //console.log("calculateAverageThrowFinals: " + roundedAverage);
        return roundedAverage;
    },
    calculateTotalThrowsMatch: function(throws) {
        var total = 0;
        for (var a = 0; a < throws.length; a++) {
            var pThrow = throws[a];
            //console.log("............pThrow " + pThrow.basicScore);
            total += parseInt(pThrow.basicScore);
        }
        return total;
    },
    calculateTotalBullseyesMatch: function(throws) {
        var total = 0;
        for (var a = 0; a < throws.length; a++) {
            var pThrow = throws[a];
            //console.log("............pThrow " + pThrow.basicScore);
            var score = parseInt(pThrow.basicScore);
            if (score == 5) total += 1;
        }
        return total;
    },
    getApiToken: function() {
      return this.token;
    },
    setupGeoLocation() {
        //do we support geolocation
        if (!("geolocation" in navigator)) {
            //console.log("Geolocation is not available.");
            return;
        }

        //get current position (latitude/longitude)
        navigator.geolocation.getCurrentPosition(pos => {
          //this.location = pos;
          //console.log(pos);

          this.$store.commit("setLocation", pos);

        }, err => { 
          //console.log("Error Getting GeoLocation: " + err.message);
        })
    },
    getTickerItems() {
      try {
        var url = (this.debugMode ? "http://localhost:8080/ticker/" : "https://axes2api.azurewebsites.net/ticker/")
        this.tickerItems = [];

        axios.get(url)
          .then((response) => {
            this.tickerItems = response.data; 
          }, (error) => {
            console.log(error);
          });

      } catch(e) {
        console.log("submitTickerItem EXCEPTION");
        console.log(e);
      }
    },
    submitBroadcastControl(item) {
      SocketioService.emitBroadcastControlItem(item);
    },
    submitPhotoControl(photo_item) {
      SocketioService.emitPhotoControlItem(photo_item);
    },
  },
  mounted () {
    this.getAdminUsers();
    setTimeout(() => {
      this.isLoading = false
    }, 1500);
    this.setupGeoLocation();
  }
}
</script>

<style lang="scss">
@font-face {
    font-family: '28 Days Later';
    src: url('fonts/28 Days Later.woff') format('woff');
}
html, body {
  background-color: black;
  color: white;
  height: 100%;
}
#app h1,h2,h3,h4,h5,h6 {
  color: white !important;
}
#app {
  background-color: #383838;
  font-family: '28 Days Later';
  letter-spacing: 3px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
  @media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}
.slider-indicator-icon {
  display: none !important;
  //width: 2px !important;
}
</style>